import { AuthServiceApi } from 'mnvm-mypage-app-auth-ts-if'
import { authConfig } from './api-config'

export const authServiceApi = new AuthServiceApi(authConfig)
